<template>
  <v-container>
    <v-app-bar color="#fff" light flat class="mobile-display">
      <div class="d-flex align-center mr-3" style="cursor: pointer">
        <v-img
          class="shrink mr-2"
          contain
          src="../assets/images/common/logo.png"
          width="70"
        />
        <span
          class="justify-center font-weight-black text-uppercase header-title"
          @click="gotoPage('homePage')"
          >{{ $t("i18n.company") }}</span
        >
      </div>
      <v-tabs
        style="margin-right: 60px"
        v-model="currentPage"
        light
        right
        slider-size="0"
        color="#0050a0"
        class="font-weight-bold"
      >
        <v-tab class="title-btn" :href="`#homePage`" @click="gotoPage('homePage')">{{ $t("i18n.homePage") }}</v-tab>
        <v-tab class="title-btn" :href="`#products`" @click="gotoPage('products')">{{ $t("i18n.products") }}</v-tab>
        <v-tab class="title-btn" :href="`#solutions`" @click="gotoPage('solutions')">{{$t("i18n.solutions")}}</v-tab>
        <v-tab class="title-btn" :href="`#apps`" @click="gotoPage('apps')" style="display:none !important">{{$t("i18n.apps")}}</v-tab>
        <v-tab class="title-btn" :href="`#about`" @click="gotoPage('about')" >{{ $t("i18n.about") }}</v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-btn class="mx-2" dark fab color="#019fe8" @click="changeLanguage()">{{
        $t("i18n.lang")
      }}</v-btn>
    </v-app-bar>
    <v-app-bar app color="#fff" light src class="pc-display">
      <div class="d-flex align-center mr-3" style="cursor: pointer">
        <v-img
          class="shrink mr-2"
          contain
          src="../assets/images/common/logo.png"
          width="50"
        />
        <span
          class="justify-center font-weight-black text-uppercase header-title"
          @click="gotoPage('homePage')"
          >{{ $t("i18n.company") }}</span
        >
      </div>
      <v-spacer></v-spacer>
      <v-btn
        class="mx-2"
        fab
        small
        dark
        light
        color="#019fe8"
        @click.stop="drawer = !drawer"
        >≡</v-btn
      >
      <v-btn
        class="mx-2"
        fab
        small
        dark
        color="#019fe8"
        @click="changeLanguage()"
        >{{ $t("i18n.lang") }}</v-btn
      >
    </v-app-bar>
    <v-app-bar app color="#fff" light flat src class="pc-display mobile-title">
      <p style="width: 100%; color: #fff">
        {{ $t("i18n." + this.currentPage) }}
      </p>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      flat
      dark
      color="#019fe8"
      temporary
      width="200px"
      overlay-opacity="0.4"
    >
      <v-list>
        <v-list-item @click="gotoPage('homePage')">{{
          $t("i18n.homePage")
        }}</v-list-item>
        <v-list-item @click="gotoPage('products')">{{
          $t("i18n.products")
        }}</v-list-item>
        <v-list-item @click="gotoPage('solutions')">{{
           $t("i18n.solutions") 
        }}</v-list-item>
        <v-list-item style="display:none !important" @click="gotoPage('apps')">{{
           $t("i18n.apps") 
        }}</v-list-item>
        <v-list-item @click="gotoPage('about')">{{
          $t("i18n.about")
        }}</v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "Header",
  computed: {
    currentPage: {
      get: function () {
        return this.$store.getters.currentPage;
      },
      set: function () {},
    },
    apps() {
      return [
        // {
        //   title: this.$t("i18n.app_ess"),
        //   page: "app_ess",
        //   logo: require("../assets/images/ess-logo.png"),
        // },
        // {
        //   title: this.$t("i18n.app_mea"),
        //   page: "app_mea",
        //   logo: require("../assets/images/mea-logo.jpg"),
        // },
        // {
        //   title: this.$t("i18n.app_cas"),
        //   page: "app_cas",
        //   logo: require("../assets/images/cas-logo.png"),
        // },
      ];
    },
  },
  data: () => ({
    drawer: null,
    page: "homePage",
  }),
  mounted() {
    this.loadPage();
  },
  methods: {
    gotoPage(value) {
      var path = "/" + value;
      this.$router.push({ path: path }).catch((error) => error);
      this.closeNav();
      this.set(value);
    },
    changeLanguage() {
      let local = this.$i18n.locale;
      if (!local || local === "") {
        this.$i18n.locale = "zh";
        localStorage.setItem("languageType", this.$i18n.locale);
      } else if (local === "zh") {
        this.$i18n.locale = "en";
        localStorage.setItem("languageType", this.$i18n.locale);
      } else {
        this.$i18n.locale = "zh";
        localStorage.setItem("languageType", this.$i18n.locale);
      }
      var title = "i18n." + this.currentPage;
      this.title = this.$t(title);
    },
    closeNav() {
      this.drawer = false;
    },
    set(page) {
      this.$store.dispatch("updateCurrentPage", page);
    },
    loadPage() {
      var route = this.$route.path.split("/")[1];
      if (route === "" || route === null) {
        route = "homePage";
      }
      this.$store.dispatch("updateCurrentPage", route);
    },
  },
};
</script>
<style lang="scss" scoped>
.v-navigation-drawer .v-list {
    background: #019fe8;
}
.title-btn {
  border-radius: 10px !important;
  border: 0px;
  background-color: #fff !important;
  min-width: 100px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  align-items: center;
  height: 100%;
  display: flex;
}
</style>